<template>
    <data-grid :value="value" @input="(rows) => { $emit('input', rows) }" :columns="columns" :default-sort-column="defaultSortColumn" :default-sort-direction="defaultSortDirection" @selected-all="(all) => { $emit('selected-all', all)}" @sort="(sortBy) => { $emit('sort', sortBy)}" @remove="(row) => { $emit('remove', row)}">
        <div slot-scope="{columns, isSortAsc, isSortable, sortedColumn, sortByColumn, rows, removeRow, isEmpty, selectRow, selectedAllAttrs, selectedAllEvents}" class="data-grid">
            <div class="data-grid-main">
                <table class="w-full">
                    <thead class="capitalize text-left text-white">
                        <tr class="h-40 bg-blue-darkest">
                            <th v-if="selectAll" class="flex items-center h-40 pl-10">
                                <styled-checkbox id="selectAll" name="selectAll" v-bind="selectedAllAttrs" v-on="selectedAllEvents" class="p-3 bg-white text-black border border-gray-600">
                                    <template v-slot:checked-icon>
                                        <span class="inset-0 p-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" class="fill-white"><path d="M6.61 11.89L3.5 8.78 2.44 9.84 6.61 14l8.95-8.95L14.5 4z"/></svg>
                                        </span>
                                    </template>
                                </styled-checkbox>
                            </th>
                            <slot name="header" :isSortAsc="isSortAsc" :isSortable="isSortable" :sortedColumn="sortedColumn" :sortByColumn="sortByColumn">
                                <th v-for="(column, index) in columns" :key="column.name" @click="sortByColumn(column)" :class="[!selectAll && index === 0 ? 'pl-10' : '', isSortable(column) ? 'cursor-pointer' : '', column.classes]" class="select-none">
                                    <span :class="[isSortable(column) ? 'flex items-center' : '']">
                                        <span v-if="column.label">{{ column.label }}</span>
                                        <span v-else>{{ column.name | columnHead }}</span>
                                        <span v-if="column === sortedColumn" class="pl-2">
                                            <span :class="[isSortAsc ? 'arrow-asc' : 'arrow-desc']">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="8.643" height="8.642" viewBox="0 0 8.643 8.642" class="ml-8 fill-pink"><path d="M8.474,2.828l.465,6.111L2.828,8.474Z" transform="translate(4.321 -4) rotate(45)"></path></svg>
                                            </span>
                                        </span>
                                    </span>
                                </th>
                            </slot>
                        </tr>
                    </thead>
                    <tbody>
                        <slot v-if="isEmpty" name="empty">
                            <tr class="h-12">
                                <td class="lead text-center" :colspan="columns.length">No data found</td>
                            </tr>
                        </slot>
                        <slot v-if="!isEmpty" :selectRow="selectRow">
                            <tr v-for="(row, index) in rows" :key="row.id" :class="{'bg-gray-300': isEven(index)}" class="h-12">
                                <td class="pl-10">
                                    <input type="checkbox" :value="row.selected" :checked="row.selected" @change="selectRow(row)"/>
                                </td>
                                <td v-for="(value, index) in row" :key="index">
                                    {{value}}
                                </td>
                            </tr>
                        </slot>
                    </tbody>
                </table>

                <slot name="pagination"></slot>
            </div>
        </div>
    </data-grid>
</template>

<script>
import DataGrid from '../index.js'
import StyledCheckbox from '../../forminputs/styledCheckbox'

export default {
    name: 'table-data-grid',
    props: {
        columns: {
            type: Array,
            required: true,
        },
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        defaultSortColumn: {
            type: Object,
        },
        defaultSortDirection: {
            type: String,
            default: 'asc',
        },
        selectAll : {
            type: Boolean,
            default: true,
        },
    },
    components: {
        DataGrid,
        StyledCheckbox,
    },
    filters: {
        columnHead(value) {
            return value.split('_').join(' ')
        }
    },
    methods: {
        isEven(number) {
            return number % 2 ? false : true
        },
    }
}
</script>

<style scoped>
    .arrow-asc svg {
        transform: rotate(180deg);
        margin-top: 4px;
    }

    .arrow-desc svg {
        transform: rotate(0deg);
        margin-top: -2px;
    }
</style>
